export enum AuthType {
  KICKFIN = 'kickfin',
  GOOGLE = 'google',
}

export interface IAuthRequest {
  type: AuthType;
  identity?: string;
  password?: string;
  token?: string;
  deviceId: string;
  redirectUri?: string;
}

export interface IAuthMFARequired {
  authId: string;
  phoneLast4: string;
  hasDob: boolean;
  hasPin: boolean;
}

export interface IAuthToken {
  jwt: string;
  source: string;
}

export interface IAuthResendVerificationCode {
  phoneLast4: string;
}

export interface IForgotPasswordRequest {
  identity: string;
  dateOfBirth: string;
}

export interface IForgotPasswordVerifyRequest {
  verifyCode: string;
}

export interface IForgotPasswordVerifyToken {
  token: string;
}

export interface IGoogleUserRequest {
  code: string;
  redirectUri: string;
}

export interface IGoogleUser {
  googleId: string;
  firstName: string;
  lastName: string;
  email: string;
  avatarUrl: string;
}

export interface IResetPasswordRequest {
  token: string;
  password: string;
}

export interface IResetPassword {
  msg: string;
}
